module.exports = __webpack_public_path__ + "static/media/logo-CNN.e3d69e3f.jpg";